import b from "./ghl-ui.es1199.js";
import { createTheme as x } from "./ghl-ui.es879.js";
import S from "./ghl-ui.es1180.js";
import g from "./ghl-ui.es1115.js";
import h from "./ghl-ui.es1052.js";
import v from "./ghl-ui.es1099.js";
const z = (s) => {
  const {
    textColor2: o,
    primaryColor: t,
    primaryColorHover: n,
    primaryColorPressed: d,
    inputColorDisabled: a,
    textColorDisabled: r,
    borderColor: e,
    borderRadius: p,
    // item font size
    fontSizeTiny: i,
    fontSizeSmall: m,
    fontSizeMedium: l,
    // item size
    heightTiny: u,
    heightSmall: C,
    heightMedium: c
  } = s;
  return Object.assign(Object.assign({}, b), {
    buttonColor: "#0000",
    buttonColorHover: "#0000",
    buttonColorPressed: "#0000",
    buttonBorder: `1px solid ${e}`,
    buttonBorderHover: `1px solid ${e}`,
    buttonBorderPressed: `1px solid ${e}`,
    buttonIconColor: o,
    buttonIconColorHover: o,
    buttonIconColorPressed: o,
    itemTextColor: o,
    itemTextColorHover: n,
    itemTextColorPressed: d,
    itemTextColorActive: t,
    itemTextColorDisabled: r,
    itemColor: "#0000",
    itemColorHover: "#0000",
    itemColorPressed: "#0000",
    itemColorActive: "#0000",
    itemColorActiveHover: "#0000",
    itemColorDisabled: a,
    itemBorder: "1px solid #0000",
    itemBorderHover: "1px solid #0000",
    itemBorderPressed: "1px solid #0000",
    itemBorderActive: `1px solid ${t}`,
    itemBorderDisabled: `1px solid ${e}`,
    itemBorderRadius: p,
    itemSizeSmall: u,
    itemSizeMedium: C,
    itemSizeLarge: c,
    itemFontSizeSmall: i,
    itemFontSizeMedium: m,
    itemFontSizeLarge: l,
    jumperFontSizeSmall: i,
    jumperFontSizeMedium: m,
    jumperFontSizeLarge: l,
    jumperTextColor: o,
    jumperTextColorDisabled: r
  });
}, f = x({
  name: "Pagination",
  common: S,
  peers: {
    Select: g,
    Input: h,
    Popselect: v
  },
  self: z
}), D = f;
export {
  D as default,
  z as self
};
